<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="layout--full-page">
    <video class="video-background" autoplay muted loop>
      <source :src="videoSrcMp4" type="video/mp4">
      <source :src="videoSrcWebm" type="video/webm">
      Your browser does not support the video tag.
    </video>
    <transition :name="routerTransition" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';

export default {
  data() {
    return {
      routerTransition: themeConfig.routerTransition || 'none',
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 800;
    }


    /*
    videoSrcMp4() {
      return this.isMobile
          ? '/fullpage/background-login-mobile.mp4'
          : '/fullpage/background-login-workoffice.mp4';
    },
    videoSrcWebm() {
      return this.isMobile
          ? '/fullpage/background-login-mobile.webm'
          : '/fullpage/background-login-workoffice.webm';
    }*/


  },
};
</script>

<style lang="scss">
.layout--full-page {
  position: relative;

  .video-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    opacity: 0.7;
  }

  a {
    position: relative;
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 0%;
      height: 1px;
      bottom: 0;
      background: rgba(var(--vs-primary), 0.4);
      transition: all 0.3s ease-in-out;
    }
    &::before {
      right: 50%;
    }
    &::after {
      left: 50%;
    }
  }

  a:hover {
    &::before {
      width: 50%;
    }
    &::after {
      width: 50%;
    }
  }
}
</style>
